import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DirectivesModule } from "../../directives/directives.module";
import { PipesModule } from "../../pipes/pipes.module";
import { QuickEditModalComponent } from "./quick-edit-modal.component";

@NgModule({
  declarations: [QuickEditModalComponent],
  imports: [CoreModule, DirectivesModule, PipesModule],
  exports: [QuickEditModalComponent],
})
export class QuickEditModalModule {}
